import { curry, get, first, size, tail } from 'lodash/fp';

function baseGetOneOfKeys(acceptedKeys, object) {
  var result = get(first(acceptedKeys), object);

  if (!result && size(acceptedKeys)) {
    return baseGetOneOfKeys(tail(acceptedKeys), object);
  }

  return result;
}
/**
 * Returns first found value from list of given paths to check
 *
 * @param {Array} acceptedKeys - List of paths to check using lodash/fp/get function
 * @param {object} object - object to search through
 *
 * @returns {*} result - found value or undefined if all paths fail
 *
 * @example
 * getOneOfKeys(['somekey', 'bar', 'foo'], { foo: 1, bar: 2 })
 * // returns 2
 */


export var getOneOfKeys = curry(baseGetOneOfKeys);
export default getOneOfKeys;